export const LOGIN_INPUT_USERNAME = 'LOGIN/INPUT/USERNAME'
export const LOGIN_INPUT_PASSWORD = 'LOGIN/INPUT/PASSWORD'

export const LOGIN_STATUS_WAITING = 'LOGIN/STATUS/WAITING'
export const LOGIN_STATUS_PROCESSING = 'LOGIN/STATUS/PROCESSING'
export const LOGIN_STATUS_SUCCESS = 'LOGIN/STATUS/SUCCESS'
export const LOGIN_STATUS_FAILED = 'LOGIN/STATUS/FAILED'
